import type { IconSvgObject } from './types';

const CrossIcon: IconSvgObject = [
  ["path", { d: "M13.5 3.00195H10.5C9.94772 3.00195 9.5 3.44967 9.5 4.00195V9.50195L4 9.50195C3.44772 9.50195 3 9.94967 3 10.502V13.502C3 14.0542 3.44772 14.502 4 14.502L9.5 14.502V20.002C9.5 20.5542 9.94772 21.002 10.5 21.002H13.5C14.0523 21.002 14.5 20.5542 14.5 20.002V14.502H20C20.5523 14.502 21 14.0542 21 13.502V10.502C21 9.94967 20.5523 9.50195 20 9.50195L14.5 9.50195V4.00195C14.5 3.44967 14.0523 3.00195 13.5 3.00195Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default CrossIcon;
